import type * as React from 'react';

import type { ProfilesV1UpdateProps } from 'bundles/expression-of-interest/types';
import type { ProfilesV1 } from 'bundles/naptimejs/resources/__generated__/ProfilesV1';
import type {
  API_BEFORE_SEND,
  API_ERROR,
  API_IN_PROGRESS,
  API_SUCCESS,
} from 'bundles/phoenix/components/ApiNotification';

// see https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-8.html#distributive-conditional-types
type NonFunctionPropertyNames<T> = {
  [K in keyof T]: T[K] extends Function ? never : K;
}[keyof T];
type NonFunctionProperties<T> = Pick<T, NonFunctionPropertyNames<T>>;

// data-only props from this naptime class
export type ProfilesV1Data = NonFunctionProperties<ProfilesV1>;

type BannerData = {
  id: string;
  heading?: string | React.ReactNode;
  body: string | React.ReactNode;
};

export type SkillsBannerData = Omit<BannerData, 'id'> & {
  id: string;
  durationInMinutes: number;
  testIds?: string[];
};

export const DeepLinkParams = { PRIVACY_SETTINGS: 'privacySettings' };

export type DeepLinkParam = (typeof DeepLinkParams)[keyof typeof DeepLinkParams];

export type UpdateProfileState = (updateData?: ProfilesV1UpdateProps) => void;

export type ApiStatus = typeof API_BEFORE_SEND | typeof API_ERROR | typeof API_IN_PROGRESS | typeof API_SUCCESS;
